import React from "react";
import BaseText from "../BaseText";
import TextProps, { TextType } from "../interface";

function TextBody({
  children,
  customAs,
  ...props
}: TextProps): React.ReactElement {
  return (
    <BaseText as={customAs ? customAs : "div"} type={TextType.BODY} {...props}>
      {children}
    </BaseText>
  );
}

export default TextBody;
